<script>
export default {
  name: 'GroupRankItem',
}
</script>
<script setup>
import { ref } from 'vue'
import { useGroupShowConfig } from '../composable/index'

const props = defineProps({
  item: Object,
  index: Number,
})

const emit = defineEmits(['groupFirstClick'])

const isGroupFold = ref(true)

const handleGroupClick = () => {
  isGroupFold.value = !isGroupFold.value

  if (!isGroupFold.value) {
    emit('groupFirstClick', props.item.firstId)
  }
}

// 是否显示团体参与人数 是否显示团体参与次数是否显示团体分数
const { showGroupPeronCount, showGroupCount, showGroupScore } =
  useGroupShowConfig()
</script>
<template>
  <div class="item">
    <div class="item-child1">
      <img
        v-if="index + 1 == 1"
        mode="scaleToFill"
        src="../../../assets/img/person/icon-rank1.png"
      />
      <img
        v-if="index + 1 == 2"
        mode="scaleToFill"
        src="../../../assets/img/person/icon-rank2.png"
      />
      <img
        v-if="index + 1 == 3"
        mode="scaleToFill"
        src="../../../assets/img/person/icon-rank3.png"
      />
      <div v-if="index + 1 > 3">{{ index + 1 }}</div>
    </div>
    <div class="item-child2">
      <div class="item-child2-item1" @click="handleGroupClick()">
        <span class="text">{{ item.name }}</span>
        <img
          v-if="!item.display && index !== undefined"
          class="img"
          :class="{
            arrowTransform: !isGroupFold,
            arrowTransformReturn: isGroupFold,
          }"
          alt=""
          src="@/assets/img/person/rank-down.svg"
        />
      </div>
      <div class="item-child2-item2">
        <!-- {{
         formatDuring(item.totalTime) == 0
            ? ''
            : formatDuring(item.totalTime)
        }} -->
      </div>
    </div>
    <!-- 参与人数 -->
    <div v-if="showGroupPeronCount" class="item-child3">
      {{ item.personCount || '&#45;&#45;' }}
    </div>
    <!-- 参与次数 -->
    <div v-if="showGroupCount" class="item-child3">
      {{ item.count || '&#45;&#45;' }}
    </div>
    <!-- 分数 -->
    <div v-if="showGroupScore" class="item-child4">
      {{
        $store.getters.getRankConfig?.rankBase === 1
          ? item?.totalScore || '--'
          : $store.getters.getRankConfig?.rankBase === 2
          ? item?.avgScore?.toFixed(2) || '--'
          : item?.maxScore || '--'
      }}
    </div>
  </div>
  <div v-if="!isGroupFold">
    <GroupRankItem
      v-for="(item, index) in item.ziji"
      :item="item"
      @groupFirstClick="handleGroupClick"
    />
  </div>
</template>
<style lang="scss" scoped>
// 单位排行
.item {
  min-height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;

  .item-child1 {
    width: 100px;
    font-size: 30px;
    text-align: center;
    font-weight: 400;
    color: #999999;

    img {
      width: 47px;
      height: 34px;
    }
  }

  .item-child2 {
    /* width: 200px; */
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 40px;
    .item-child2-item1 {
      display: flex;
      align-items: center;

      .text {
        text-align: left;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 40px;
      }

      .img {
        width: 25px;
        height: 17px;
      }
    }

    .item-child2-item2 {
      font-size: 23px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      padding-top: 14px;
    }
  }

  .item-child3 {
    width: 130px;
    text-align: center;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #555555;
  }

  .item-child4 {
    width: 140px;
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #018af9;
  }
}
</style>
